import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { syncGuestDataToServer } from "../utils/syncGuestData";

const SellerAdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.email.trim() || !formData.password.trim()) {
    toast.error("Please enter email and password");
    return;
  }

  try {
    const payload = new FormData(); 
    payload.append("email", formData.email.trim());
    payload.append("password", formData.password.trim());

    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/login_seller_registration",
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    console.log("Login Response:", response.data);

    if (response.data.status === "true") {

      const sellerData = response.data.data;

      if(sellerData.admin_approval !== "yes"){
        toast.warn("Your account is pending admin approval.");
        return;
      }else{
        toast.success("Login successful!");
      }
      localStorage.setItem("seller", JSON.stringify(sellerData));
      localStorage.setItem("seller_id", sellerData.seller_id);
      localStorage.setItem("role", sellerData.role);
      console.log("Seller ID stored:", sellerData.seller_id);
      console.log("Seller Role stored:", sellerData.role);

      window.dispatchEvent(new Event("sellerLoggedIn"));

      setTimeout(() => {
        navigate("/admin-dashboard");
      }, 1000);
    } else {
      toast.error(response.data.message || "Invalid credentials");
    }
  } catch (error) {
    console.error("Login error:", error);
    toast.error(
      error.response?.data?.message || "Invalid mobile/email or password"
    );
  }
};




  return (
    <div className="container-fluid login-section">
      <div id="loginbox">
        <img
          src="https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/2021/7/14/1db28809-f3db-48b1-b303-d937716565661626257521634-Banner_Hamburger--2---1-.jpg"
          alt="Login Banner"
        />
        <div className="loginbody">
          <div className="loginheader">
            Login <span id="smallheader">Or </span>Signup
          </div>

          <form onSubmit={handleSubmit} id="login">
            <label>
              Mobile No. <span id="smallheader">Or </span> Email
            </label>
            <input
              required
              placeholder="Enter Your Mobile Number Or Email"
              name="email"
              id="email"
              type="text"
              value={formData.email}
              onChange={handleChange}
            />

            <label>Password</label>
            <input
              required
              placeholder="Enter Your Password"
              name="password"
              id="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
            />

            <button type="submit" className="continue">
              CONTINUE
            </button>
          </form>

          <p>
            By continuing I agree to the{" "}
            <span className="smallhead">
              <Link to="/PrivacyPolicy"> Terms of Use </Link>
            </span>
            &amp;
            <span id="small">
              <Link to="/PrivacyPolicy"> Privacy Policy </Link>
            </span>
          </p>

          <p>
            Don't have an account?{" "}
            <Link to="/register">
              <span style={{ cursor: "pointer" }}>Signup</span>
            </Link>
          </p>

          <div id="alert" />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default SellerAdminLogin;